import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/app';
import Login from './containers/login';
import Cookies from 'universal-cookie';
import Kol from './containers/kol';
import Profile from './containers/profile';
import Account from './containers/account';
import MyKolList from './containers/mykollist';
import Meta from './containers/meta';
import Compare from './containers/compare';
// import Overview from './containers/overview';
// import PostInteraction from './containers/post_interaction';
// import Fanpost from './containers/fanpost';
// import FanAnalysis from './containers/fananalysis';
// import FanAnalysis from './containers/fansintersection';
// import FanGroup from './containers/fangroup';
// import PostType from './containers/posttype';
// import Profile from './containers/manage_profile';
// import UserSetting from './containers/user_setting';
// import Loyalty from './containers/loyalty';

let cookies = new Cookies();

/****** Creating a Single-Page App in React using React Router ******/
/****** Uses React router to provide all of the navigation and view-loading ******/
/****** App.js <article className="main"></article> receive the following components ******/
/****** as its children(by using this.props.children) ******/

function requireAuth(nextState, replace, cb) {

    if (!cookies.get('token')) {
        replace({
            pathname: '/login',
            state: { nextPathname: '/' }
        })
    }

    cb();
}

export default (
  <Route path="/" component={App}>
    <Route path="login" component={Login} />
    <Route onEnter={requireAuth}>
        <IndexRoute component={Kol} />
        {/*
        <Route path="overview" component={Overview} />
        <Route path="post_interaction" component={PostInteraction} />
        <Route path="fanpost" component={Fanpost} />
        <Route path="fananalysis" component={FanAnalysis} />
        <Route path="fangroup" component={FanGroup} />
        <Route path="posttype" component={PostType} />
        <Route path="user_setting" component={UserSetting} />
        */}
        <Route path="kol" component={Kol} />
        <Route path="profile" component={Profile} />
        <Route path="meta" component={Meta} />
        <Route path="account" component={Account} />
        <Route path="mylist" component={MyKolList} />
        <Route path="compare" component={Compare} />
    </Route>
  </Route>
);


// WEBPACK FOOTER //
// ./src/routes.js